module.exports = require("@supabase/supabase-js");